import { Directive, Input, TemplateRef, inject } from '@angular/core';

/** Context passed to `appTableCell` templates. */
export interface TableCellTemplateContext<T = unknown> {
  $implicit: T;
  row: T;
}

/**
 * Marks an `ng-template` as a custom cell renderer for a table column.
 *
 * @example
 * <app-table [columns]="columns" [data]="rows">
 *   <ng-template appTableCell="isActive" let-row>
 *     <mat-slide-toggle [checked]="row.isActive" />
 *   </ng-template>
 * </app-table>
 */
@Directive({
  selector: '[appTableCell]',
})
export class TableCellTemplateDirective {
  readonly template = inject(TemplateRef<TableCellTemplateContext>);

  @Input({ required: true, alias: 'appTableCell' })
  columnKey!: string;
}
